export const sizes = {
  '0_5': '2px',
  1: '4px',
  1_5: '6px',
  2: '8px',
  3: '12px',
  4: '16px',
  '4_5': '18px',
  5: '20px',
  '5_5': '22px',
  6: '24px',
  7: '28px',
  8: '32px',
  9: '36px',
  10: '40px',
  12: '48px',
  14: '56px',
  16: '64px',
  xs: '$4_5',
  s: '$5_5',
  sm: '$6',
  md: '$9',
}

export const fontSizes = {
  '0_5': '10px',
  1: '12px',
  2: '14px',
  3: '16px',
  4: '18px',
  5: '20px',
  6: '24px',
  7: '28px',
  8: '35px',
  9: '60px',
  sm: '$1',
  xs: '$0_5',
}

export const space = {
  '0_5': '0.125rem', // 2px
  1: '0.25rem', // 4px
  '1_5': '0.375rem', // 4px
  2: '0.5rem', // 8px
  3: '0.75rem', // 12px
  4: '1rem', // basic px is 16
  5: '1.25rem', // 20px
  6: '1.5rem', // 24px
  7: '1.75rem',
  8: '2rem',
  9: '2.25rem',
  10: '2.5rem',
  12: '3rem',
  14: '3.5rem',
  16: '4rem',
  20: '5rem',
  24: '6rem',
  28: '7rem',
  32: '8rem',
  36: '9rem',
  40: '10rem',
  44: '11rem',
  48: '12rem',
  52: '13rem',
  56: '14rem',
  60: '15rem',
  64: '16rem',
  72: '18rem',
  80: '20rem',
  96: '24rem',
}

export const radii = {
  1: '2px',
  2: '4px',
  3: '6px',
  4: '8px',
  5: '10px',

  round: '9999px',
}

export const shadows = {
  2: `
    0px 0px .5px rgba(0, 0, 0, .5),
    0px 2px 6px 0px rgba(0, 0, 0, .2),
    inset 0px .5px 0px rgba(255, 255, 255, .1),
    inset 0px 0px .5px rgba(255, 255, 255, .3)
  `,
  3: `
    0px 0px .5px rgba(0, 0, 0, .5),
    0px 2px 6px 0px rgba(0, 0, 0, .2),
    inset 0px .5px 0px rgba(255, 255, 255, .1),
    inset 0px 0px .5px rgba(255, 255, 255, .3)
  `,
  border: `inset 0 0 0 1px $colors$grayA3`,
  popContainer: `
    0px 0px .5px rgba(0, 0, 0, .5),
    0px 2px 6px 0px rgba(0, 0, 0, .2),
    inset 0px .5px 0px rgba(255, 255, 255, .1),
    inset 0px 0px .5px rgba(255, 255, 255, .3)
  `,
  prepend: '0 0 0 0 transparent',
}
